<template>
  <div>
    <h2 class="is-size-5 has-text-weight-bold">Grading</h2>
    <p class="has-text-grey">Move the sliders to change the score for each rubric.</p>
    <br>
    <GradingRubric
      v-for="rubric in rubrics"
      :key="rubric.slug"
      :name="rubric.name"
      :slug="rubric.slug"
      @changedScore="saveScore"
      @changedComment="saveComment"
    />
    <br>
    <div class="level">
      <div class="level-left" />
      <div class="level-right submit-area">
        <div class="d-flex align-center">
          <span class="is-size-5">Total Score:&nbsp;<b>{{ average }}</b>&nbsp;&nbsp;</span>
          <a
            href="#"
            class="button is-primary is-medium"
            @click.prevent="submit"
          >Submit</a>
        </div>
        <div>
          <small><b>Note:&nbsp;</b>after submitting you won't be able to edit the scores</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GradingRubric from '@/components/submissions/GradingRubric'

export default {
  name: 'Grading',
  components: {
    GradingRubric
  },
  data () {
    return {
      average: 5.5,
      rubrics: [
        {
          name: 'Speed',
          slug: 'speed',
          comment: '',
          score: 5.5
        },
        {
          name: 'Power',
          slug: 'power',
          comment: '',
          score: 5.5
        },
        {
          name: 'Stances',
          slug: 'stances',
          comment: '',
          score: 5.5
        },
        {
          name: 'Spirit',
          slug: 'spirit',
          comment: '',
          score: 5.5
        },
        {
          name: 'Technical Proficiency',
          slug: 'technical-proficiency',
          comment: '',
          score: 5.5
        }
      ]
    }
  },
  watch: {
    rubrics () {
      let arr = []
      this.rubrics.map(item => {
        arr.push(item.score)
      })
      this.average = Math.round(arr.reduce((a, b) => { return a + b }) / arr.length * 100) / 100
    }
  },
  methods: {
    saveScore (data) {
      let i = this.rubrics.findIndex(item => {
        return item.slug === data.slug
      })
      let rubric = this.rubrics[i]
      rubric.score = parseFloat(data.value)
      this.rubrics.splice(i, 1, rubric)
    },
    saveComment (data) {
      let i = this.rubrics.findIndex(item => {
        return item.slug === data.slug
      })
      let rubric = this.rubrics[i]
      rubric.comment = data.value
      this.rubrics.splice(i, 1, rubric)
    },
    submit () {
      this.$emit('saveRubrics', {
        score: this.average,
        rubrics: this.rubrics
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .submit-area{
    flex-direction: column;
    align-items: flex-end;
  }
</style>
